export function Logo({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="Holiday Flags"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Flagpole */}
      <rect x="6" y="3" width="2.2" height="26" rx="1.1" fill="currentColor" opacity="0.85" />
      {/* Furling flag, drawn as a single wave so it stays legible at 16px */}
      <path
        d="M9 5.2c4.6-2.3 9.1 2.1 13.7-0.2v9.6c-4.6 2.3-9.1-2.1-13.7 0.2V5.2Z"
        fill="currentColor"
      />
      <circle cx="7.1" cy="3" r="1.6" fill="currentColor" />
    </svg>
  )
}
